import { jsx as m } from "react/jsx-runtime";
import { clsx as s } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import o from "./roche-badge.module.scss.js";
import { RocheUIBadgeColor as t } from "./roche-badge.types.js";
const i = ({ text: r, color: e = t.BLUE }) => /* @__PURE__ */ m("span", { className: s(o.badge, o[`badge--${e}`]), children: r });
export {
  i as RocheUIBadge
};
